/**
 * Independent time operation tool to facilitate subsequent switch to dayjs
 */
import dayjs from 'dayjs';

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const DATE_FORMAT = 'YYYY-MM-DD';

export function formatToDateTime(date?: dayjs.ConfigType, format = DATE_TIME_FORMAT): string {
  return dayjs(date).format(format);
}

export function formatToDate(date?: dayjs.ConfigType, format = DATE_FORMAT): string {
  return dayjs(date).format(format);
}

/**
 * 智能日期时间：今年省略年份；今日/明日/后天用相对日 + 时分
 * @example 今日 00:44 / 明日 12:00 / 08-12 09:00 / 2025-12-01 09:00
 */
export function formatSmartDateTime(date?: dayjs.ConfigType): string {
  if (date == null || date === '') {
    return '';
  }
  const target = dayjs(date);
  if (!target.isValid()) {
    return '';
  }

  const now = dayjs();
  const dayDiff = target.startOf('day').diff(now.startOf('day'), 'day');
  const time = target.format('HH:mm');

  if (dayDiff === 0) {
    return `今日 ${time}`;
  }
  if (dayDiff === 1) {
    return `明日 ${time}`;
  }
  if (dayDiff === 2) {
    return `后天 ${time}`;
  }
  if (target.year() === now.year()) {
    return target.format('MM-DD HH:mm');
  }
  return target.format('YYYY-MM-DD HH:mm');
}

export const dateUtil = dayjs;

